/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { getFormItemClassName } from '../../helpers/form';
import { IFormItemProps } from '../../types/components/form';
import { ITextareaLayout } from '../../types/layout/textarea';

type TTextAreaProps = ITextareaLayout & IFormItemProps;

function Textarea({
    disabled, placeholder, onChange, value, additionalClassName,
}: ITextareaLayout & TTextAreaProps) {
    const onChangeHandler: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
        if (typeof onChange === 'function') {
            onChange(e.target.value);
        }
    };

    return (
        <textarea
            disabled={disabled}
            className={getFormItemClassName('form-control', additionalClassName)}
            placeholder={placeholder}
            onChange={onChangeHandler}
            value={value}
        />
    );
}

Textarea.defaultProps = {
    placeholder: undefined,
    onChange: undefined,
    value: undefined,
};

export default Textarea;
